/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import dayjs from "dayjs";
import { ReportType, MonthlyReportInput } from "~/generated/graphql";
import { Option } from "~/models";
import { isNotEmpty } from "~/tools";
import { MONTH_OPTIONS, newestReportDate } from "./constants";
import { FormData } from "./types";

export function getMonthOptions(minDate: string, year: string): Option[] {
  const minimalDate = dayjs(minDate);

  return MONTH_OPTIONS.filter((month) => {
    const date = dayjs(`${year}-${month.value}-01`);

    return date.diff(newestReportDate) < 0 && date.diff(minimalDate) >= 0;
  });
}

export function getRequestData(formData: FormData): MonthlyReportInput {
  const { year, month } = formData;

  const data: MonthlyReportInput = {
    period: `${year}-${month}`,
    reportType: ReportType.MonthlyReportFull,
  };
  const hasBusinessContext =
    formData.businessContext.checked &&
    isNotEmpty(formData.businessContext.value);

  if (hasBusinessContext) {
    data.reportType = ReportType.MonthlyReportBc;
    data.businessContextId = formData.businessContext.value;
  }

  return data;
}
